import { GradientCotnainer } from "../GradientContainer";
import { IoLocationOutline, IoPersonOutline } from "react-icons/io5";
import { MdNotificationsNone } from "react-icons/md";
import { IoLogOutOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import { useLocation } from "@/contexts/LocationContext";
import { useNavigate } from "react-router-dom";
import { clearAuthData } from "@/utils/jwt";
import { useSSENotifications } from "@/hooks/useSSENotifications";
import { useGetUnreadCount } from "@/hooks/useNotifications";
import PrefLogo from "@/assets/logo_municipal.svg";

export const AppBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const { location } = useLocation();
  const navigate = useNavigate();
  const { isConnected, lastNotification } = useSSENotifications(true);
  const { data: unreadCount = 0, refetch } = useGetUnreadCount();

  // Refetch do count quando chegar nova notificação
  useEffect(() => {
    if (lastNotification && !lastNotification.isRead) {
      refetch();
    }
  }, [lastNotification, refetch]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const locationText = location
    ? `${location.city}${location.state ? `, ${location.state}` : ""}`
    : "Localização não disponível";

  const handleLogout = () => {
    clearAuthData();
    navigate("/login");
  };

  return (
    <div
      className={`fixed top-0 left-0 right-0 px-3 md:px-5 py-3 md:py-4 w-full flex items-center justify-center z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-md shadow-md" : "bg-white"
      }`}
    >
      <div className="w-full max-w-7xl lg:max-w-full mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2 md:gap-3 flex-1 min-w-0">
          <img
            src={PrefLogo}
            alt="Logo Municipal"
            className="w-10 h-10 md:w-12 md:h-12 object-contain flex-shrink-0"
          />
          <div className="flex flex-col gap-0 min-w-0">
            <span className="text-[10px] md:text-xs text-gray-500 font-semibold uppercase tracking-wide leading-none">
              
            </span>
            <span className="font-bold text-sm md:text-base whitespace-nowrap leading-tight truncate bg-gradient-to-r from-[hsl(var(--primary))] to-[hsl(var(--secondary))] bg-clip-text text-transparent">
              Vida+Simples
            </span>
            <div className="flex items-center gap-1 mt-0.5">
              <IoLocationOutline className="text-primary text-xs md:text-sm flex-shrink-0" />
              <span className="text-gray-400 font-semibold text-xs md:text-sm truncate">
                {locationText}
              </span>
            </div>
          </div>
        </div>
        <div className="flex-shrink-0 flex items-center gap-2">
          <div
            className="relative w-9 h-9 md:w-10 md:h-10 rounded-lg md:rounded-xl flex items-center justify-center bg-gray-200 hover:bg-gray-300 transition-colors cursor-pointer"
            onClick={() => {
              navigate("/alerts");
            }}
          >
            <MdNotificationsNone className="text-lg md:text-xl text-gray-500" />

            {/* Badge numérico de notificações não lidas */}
            {unreadCount > 0 && (
              <div className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 bg-red-500 rounded-full border-2 border-white flex items-center justify-center">
                <span className="text-[10px] font-bold text-white leading-none">
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              </div>
            )}

            {/* Indicador de conexão SSE */}
            {isConnected && (
              <div className="absolute -bottom-0.5 -right-0.5 w-2 h-2 bg-green-500 rounded-full border border-white" />
            )}
          </div>
          <button
            onClick={() => navigate("/profile")}
            className="w-9 h-9 md:w-10 md:h-10 rounded-lg md:rounded-xl flex items-center justify-center bg-[hsl(var(--primary))]/10 hover:bg-[hsl(var(--primary))]/20 transition-colors cursor-pointer"
            title="Perfil"
          >
            <IoPersonOutline className="text-lg md:text-xl text-[hsl(var(--primary))]" />
          </button>
          <button
            onClick={handleLogout}
            className="w-9 h-9 md:w-10 md:h-10 rounded-lg md:rounded-xl flex items-center justify-center bg-red-100 hover:bg-red-200 transition-colors cursor-pointer"
            title="Sair"
          >
            <IoLogOutOutline className="text-lg md:text-xl text-red-600" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppBar;
